import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import React from 'react';

const PackageSkeleton = () => {
  return (
    <div className='package-skeleton'>
        <div className='title'>
          <Skeleton />
        </div>
        <div className='package-info'>
          <Skeleton />
          <Skeleton height={40} />
        </div>
        <div className='social-netoworks'>
          <Skeleton circle width={14} height={14} />
          <Skeleton circle width={14} height={14} />
          <Skeleton circle width={14} height={14} />
          <Skeleton circle width={14} height={14} />
          <Skeleton circle width={14} height={14} />
        </div>
        <div className='under-icon-line'>
          <Skeleton />
        </div>
        <div className='details-per-service'>
          <Skeleton  />
        </div>
        <div className='button-and-price'>
          <Skeleton width={80} height={20} />
          <Skeleton width={80} height={20} />
        </div>
        <div className='countries-and-good-to-know'>
          <Skeleton width={80} height={20}/>
          <Skeleton width={80} height={20} />
        </div>
        <div className='family-member-discount-container'>
          <div className='family-member-discount'>
          <Skeleton height={50}/>
          </div>
        </div>
    </div>
  );
};

export default PackageSkeleton;
